<template>
	<div class="container h-100">
		<div class="row h-100 justify-content-center align-items-center">
			<div class="col-lg-6">
				<div class="card">
					<div class="card-body">
						<h1>Success!</h1>
						<p>Your password has been reset!</p>
						<BLink tag="button" class="btn btn-primary"
							href="/login">
							Continue to Login <BIcon icon="arrow-right"></BIcon>
						</BLink>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PasswordResetSuccess'
	}
</script>

<style scoped>

</style>
